import React from 'react';
import { DebounceInput as InputDebounce } from 'react-debounce-input';

import { DEBOUNCE_TIME } from 'constants/Global';
import { Input } from 'ui/base';

/** @type {React.ForwardRefExoticComponent<import('antd').InputProps & { allowClear?: boolean; children?: React.ReactNode } & React.RefAttributes<import('antd').InputRef>>} */
const DebounceInput = React.forwardRef(({ children, ...props }, ref) => (
  <InputDebounce
    element={Input}
    debounceTimeout={DEBOUNCE_TIME}
    {...props}
    inputRef={ref}
  >
    {children}
  </InputDebounce>
));

export default DebounceInput;
